import "esbuild-css-modules-plugin-ns-css:src/js/components/topicTile/topicTileStyle.module.css";

import { inject } from "esbuild-css-modules-plugin-ns-js:src/js/components/topicTile/topicTileStyle.module.css:injector.js";
export default new Proxy({
  "arrow": "topicTileStyle-module__arrow_lqX4wG__1100",
  "contentBox": "topicTileStyle-module__contentBox_lqX4wG__1100",
  "iconContainer": "topicTileStyle-module__iconContainer_lqX4wG__1100",
  "label": "topicTileStyle-module__label_lqX4wG__1100",
  "labelContainer": "topicTileStyle-module__labelContainer_lqX4wG__1100",
  "labelHover": "topicTileStyle-module__labelHover_lqX4wG__1100"
}, {
  get: function(source, key) {
    inject();
    return source[key];
  }
});
      